<template>
  <v-row class="cfs-page-header mx-md-0 mx-3 sm:py-4" no-gutters>
    <v-col
      cols="12"
      :md="!isEmpty && 6"
      class="cfs-page-header-left d-flex d-md-block justify-start mb-md-0 mb-2"
    >
      <template v-if="$hasSlot('left')">
        <slot name="left"></slot>
      </template>
      <template v-else>
        <h2 class="cfs-page-header-title" :class="headerClass">{{ title }}</h2>
      </template>
    </v-col>
    <v-col v-if="!isEmpty && layout !== 'tablet'" cols="12" md="6" class="d-flex justify-end">
      <slot></slot>
    </v-col>
  </v-row>
</template>

<script>
import { useLayout } from '@/composables/useLayout';

export default {
  props: {
    title: {
      type: String,
      default: null,
      required: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { layout } = useLayout();

    return {
      layout,
    };
  },
};
</script>

<style lang="scss" scoped>
.cfs-page-header {
  margin: 0 2rem;

  .cfs-page-header-title {
    color: var(--v-title-base);
    font-weight: 500;
  }
}
</style>
